<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Filtros">
        <NxInput
          v-model="form.numero"
          name="numero"
          type="text"
          label="Número:"
          placeholder="Digite o número do WhatsApp"
          @update:value="handleInputUpdate('numero', $event)"
        />
        <NxInput
          v-model="form.data"
          name="data"
          type="date"
          label="Data do pedido:"
          placeholder="Escolha a data"
          @update:value="handleInputUpdate('data', $event, false)"
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'

export default {
  name: 'SidebarBlockListWhatsApp',
  components: { SidebarSearch, SearchCollapse },
  data () {
    return {
      form: {
        numero: null,
        data: null
      }
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.form.numero = null
      this.form.data = null
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        if (fieldName === 'numero') {
          this.form[fieldName] = clean
            ? inputedValue.replace(/\D/g, '')
            : inputedValue
        } else {
          this.form[fieldName] = inputedValue
        }
      } else {
        this.form[fieldName] = null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/blocklist/BlockList/components/search/SidebarBlockListWhatsApp.vue